import { FormModel } from "mvc-kit/forms";
//#region src/modules/AuthWrapper2/models/NewPasswordModel.ts
var NewPasswordModel = class extends FormModel {
	validate(state) {
		const errors = {};
		if (!state.newPassword) errors.newPassword = "Required";
		else if (state.newPassword.length < 5) errors.newPassword = "Must be at least 5 characters";
		if (!state.newPasswordConfirm) errors.newPasswordConfirm = "Required";
		else if (state.newPassword !== state.newPasswordConfirm) errors.newPasswordConfirm = "Passwords must match";
		return errors;
	}
	setNewPassword(newPassword) {
		this.set({ newPassword });
	}
	setNewPasswordConfirm(newPasswordConfirm) {
		this.set({ newPasswordConfirm });
	}
};
//#endregion
export { NewPasswordModel };

//# sourceMappingURL=NewPasswordModel.js.map